import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
// import CsvDownloadEsButton from '../../components/atoms/CsvDownloadEsButton';
import ShopRegisterButton from '../../components/atoms/ShopRegisterButton';
import StepBackButton from '../../components/atoms/StepBackButton';
import ShopTable from '../organisms/ShopTable';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getShops,
  downloadShop,
  getShopEs,
  downloadShopEs
} from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import ShopAddAdmin from '../organisms/ShopAddAdmin';
// import ESSearchButton from '../../components/atoms/ESSearchButton';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonGroupRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      identityStatuses: state.identities.statuses,
      shopStatuses: state.shops.shopStatuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShops, downloadShop, getAccounts, getShopEs, downloadShopEs },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openShopAdd', 'updateOpenShopAdd', false),
  withState('openShopAddConfirm', 'updateOpenShopAddConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopId', 'setShopId', ''),
  withState('cityId', 'setCityId', ''),
  withState('groupName', 'setGroupName', ''),
  withState('address', 'setAddress', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityStatus', 'setIdentityStatus', ''),
  withState('shopStatus', 'setShopStatus', ''),
  withState('searchSortKey', 'setSearchSortKey', ''),
  withState('sortOrder', 'setSortOrder', ''),
  withState('openSort', 'updateOpenSort', false),
  withState('searchEs', 'setSearchEs', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (
      event,
      page,
      limit,
      searchSortKey,
      sortOrder
    ) => {
      const table = document.getElementById('scrollTableId');
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      props.setPage(page);
      props.setSearchSortKey(searchSortKey);
      props.setSortOrder(sortOrder);
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        shopName: props.shopName,
        groupName: props.groupName,
        address: props.address,
        identityStatus: props.identityStatus,
        shopStatus: props.shopStatus,
        shopId: props.shopId,
        searchSortKey,
        // sortType,
        sortOrder,
        page,
        limit: limit || limitNum,
        isAdminCall: 1
      };
      props.updateLoading(true);
      props.updateOpenProgress(true);
      if (!props.searchEs) {
        props.actions
          .getShops(searchKey)
          .then(data => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.error === true && data.payload.status !== 200) {
              props.updateOpenProgress(true);
              props.setResultMessage('エラーが発生しました。');
            }
          })
          .catch(e => {
            console.log('locnh', e);
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
          });
      } else {
        props.actions
          .getShopEs(searchKey)
          .then(data => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.error === true && data.payload.status !== 200) {
              props.updateOpenProgress(true);
              props.setResultMessage('エラーが発生しました。');
            }
          })
          .catch(() => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
          });
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        const searchShopId = queryString.parse(this.props.location.search)
          .shopId;
        if (data.payload.role === 'SHOP') {
          this.props.actions
            .getShops({
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(shopData => this.props.checkSession(shopData));
          this.props.updateOpenTable(true);
        } else if (searchShopId) {
          await this.props.actions
            .getShops({
              shopId: searchShopId,
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(shopData => {
              this.props.checkSession(shopData);
              this.props.setShopName(shopData.payload.shops[0].shopName);
            });
          this.props.updateOpenTable(true);
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    checkSession,
    handleRedirect,
    handleChangePage,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    openShopAdd,
    updateOpenShopAdd,
    openShopAddConfirm,
    updateOpenShopAddConfirm,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    shopName,
    setShopName,
    shopId,
    setShopId,
    cityId,
    setCityId,
    groupName,
    setGroupName,
    address,
    setAddress,
    page,
    identityStatuses,
    identityStatus,
    setIdentityStatus,
    shopStatuses,
    shopStatus,
    setShopStatus,
    searchSortKey,
    setSearchSortKey,
    // sortType,
    // setSortType,
    sortOrder,
    setSortOrder,
    openSort,
    updateOpenSort,
    searchEs,
    setSearchEs
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      resultMessage,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      shopName,
      groupName,
      address,
      identityStatus,
      shopStatus,
      shopId,
      searchSortKey,
      sortOrder,
      page,
      limit: limitNum
    };

    useEffect(() => {
      handleChangePage(null, 1, limitNum, searchSortKey, sortOrder);
    }, [searchEs]);

    const searchAction = async () => {
      setSearchEs(false);
      updateOpenTable(true);
      if (!searchEs) {
        handleChangePage(null, 1, limitNum, searchSortKey, sortOrder);
      }
      // handleChangePage(null, 1, limitNum, searchSortKey, sortOrder, false);
      // updateOpenProgress(true);
      // await actions
      //   .getShops(searchKey)
      //   .then(data => {
      //     checkSession(data);
      //     updateOpenProgress(false);
      //     setResultMessage('');
      //     updateLoading(false);
      //     handleChangePage(null, page, limit);
      //     updateOpenTable(true);
      //   })
      //   .catch(() => {
      //     updateOpenProgress(false);
      //     setResultMessage('');
      //     updateLoading(false);
      //   });
    };

    // const searchEsAction = async () => {
    //   setSearchEs(true);
    //   updateOpenTable(true);
    //   if (searchEs) {
    //     handleChangePage(null, 1, limitNum, searchSortKey, sortOrder);
    //   }
    // };

    const sortServerAction = async (
      searchSortKeyColumn,
      // sortTypeParamServer,
      sortOrderParam
    ) => {
      // setSortType('server');
      const isDesc = sortOrderParam === 'desc';
      console.log('sonph, sortOrderParam ===', sortOrderParam);
      setSortOrder(isDesc ? 'asc' : 'desc');
      setSearchSortKey(searchSortKeyColumn);
      const testOrderParam = isDesc ? 'asc' : 'desc';
      console.log('sonph, testOrderParam ===', testOrderParam);
      updateOpenTable(true);
      handleChangePage(
        null,
        page,
        limitNum,
        searchSortKeyColumn,
        // sortTypeParamServer,
        testOrderParam
      );
      updateOpenSort(false);
    };
    const sortClientAction = async (searchSortKeyColumn, sortOrderParam) => {
      console.log('searchSortKeyColumn', searchSortKeyColumn);
      console.log('sortOrderParam', sortOrderParam);
      const isDesc =
        searchSortKey === searchSortKeyColumn && sortOrderParam === 'desc';
      setSortOrder(isDesc ? 'asc' : 'desc');
      setSearchSortKey(searchSortKeyColumn);
      updateOpenProgress(false);
      setResultMessage('');
      updateLoading(false);
      updateOpenTable(true);
      updateOpenSort(false);
    };
    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        linkEl.parentNode.removeChild(linkEl);
        // iOSのクリックイベント対策
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const cloneSearchKey = { ...searchKey };
      cloneSearchKey.isAdminCall = 1;
      const response = await actions
        .downloadShop(cloneSearchKey)
        .then(data => checkSession(data));
      if (response.type === 'DOWNLOAD_SHOP_SUCCESS') {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        downloadCsvBlob(response.payload, `${timeStamp}_shop_info.csv`);
      } else {
        setResultMessage('店舗情報ダウンロードに失敗しました。');
        updateLoading(false);
      }
    };

    // const csvDownloadEsAction = async () => {
    //   updateLoading(true);
    //   updateOpenProgress(true);
    //   const response = await actions
    //     .downloadShopEs(searchKey)
    //     .then(data => checkSession(data));
    //   if (response.type === 'DOWNLOAD_SHOP_ES_SUCCESS') {
    //     const timeStamp = moment()
    //       .tz('Asia/Tokyo')
    //       .format('YYYYMMDDHHmm');
    //     updateOpenProgress(false);
    //     setResultMessage('');
    //     updateLoading(false);
    //     downloadCsvBlob(response.payload, `${timeStamp}_shop_info.csv`);
    //   } else {
    //     setResultMessage('店舗情報ダウンロードに失敗しました。');
    //     updateLoading(false);
    //   }
    // };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const registerOpenAction = () => updateOpenShopAdd(true);
    const shopCancelAction = () => updateOpenShopAdd(false);
    const shopBackAction = () => updateOpenShopAddConfirm(false);
    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            店舗検索
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="運営会社名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={groupName}
                  onChange={e => {
                    setGroupName(e.target.value);
                    // setSearchSortKey('abc');
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  select
                  label="審査状況"
                  className={classes.textField}
                  margin="normal"
                  value={identityStatus}
                  onChange={e => {
                    setIdentityStatus(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {identityStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  select
                  label="開店状況"
                  className={classes.textField}
                  margin="normal"
                  value={shopStatus}
                  onChange={e => {
                    setShopStatus(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {shopStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              )}
            </div>
            <div>
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗ID"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopId}
                  onChange={e => {
                    setShopId(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="住所"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={address}
                  onChange={e => {
                    setAddress(e.target.value);
                  }}
                />
              )}
            </div>
            {(roles.isSecretariat || roles.isDeveloper) && (
              <div>
                <div className={classes.buttonGroupLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
                <div className={classes.buttonGroupRight}>
                  <ShopRegisterButton onClickAction={registerOpenAction} />
                  <CsvDownloadButton onClickAction={csvDownloadAction} />
                </div>
              </div>
            )}
            {roles.isGroup && (
              <div>
                <SearchButton onClickAction={searchAction} />
              </div>
            )}
          </div>
          {openTable && (
            <ShopTable
              openSort={openSort}
              roles={roles}
              progress={progress}
              searchKey={searchKey}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              sortClientAction={sortClientAction}
              sortServerAction={sortServerAction}
              searchSortKey={searchSortKey}
              sortOrder={sortOrder}
              // sortType={sortType}
            />
          )}
          {isShop && !isReleased && (
            <div>
              <StepBackButton onClickAction={backAction} />
            </div>
          )}
        </Paper>
        <div>
          <Modal open={openShopAdd}>
            <ShopAddAdmin
              openShopAddConfirm={openShopAddConfirm}
              updateOpenShopAdd={updateOpenShopAdd}
              updateOpenShopAddConfirm={updateOpenShopAddConfirm}
              cancelAction={shopCancelAction}
              backAction={shopBackAction}
              searchKey={searchKey}
              roles={roles}
              cityId={cityId}
              setCityId={setCityId}
            />
          </Modal>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        {/* {isShop && isReleased && <MenuBox account={account} />} */}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main)); // <CsvDownloadEsButton onClickAction={csvDownloadEsAction} />
